// import React from 'react';
// import {
// 	Button,
// 	CardMedia,
// 	List,
// 	ListItem,
// 	ListItemIcon,
// 	ListItemText,
// 	Typography,
// } from '@mui/material';
// import Grid from '@mui/material/Grid';
// import { useNavigate } from 'react-router-dom';
// import CallIcon from '@mui/icons-material/Call';
// import {
// 	Root,
// 	SlideUp,
// 	StyledTypographhheroheanding,
// 	TextContainer,
// } from '../../../component/ThemeComponent';
// import './Heroheader.css'; // Import the CSS file for animations
// // import SeemandhamAnimation from './Semathana';
// import SeemandhamFlag from './Semathana';

// const Herobanner = () => {
// 	const navigate = useNavigate();

// 	return (
// 		<Root>
// 			<Grid
// 				container
// 				spacing={2}
// 				direction="row"
// 				justifyContent="center"
// 				alignItems="center"
// 				sx={{ height: '100%' }}
// 			>
// 				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
// 					<Grid container>
// 						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}></Grid>
// 						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
// 							<TextContainer
// 								className="hero-banner"
// 								sx={{ padding: { xs: '5px 20px', lg: '0px' } }}
// 							>
// 								<SeemandhamFlag />
// 								<SlideUp style={{ animationDelay: '0.1s' }}>
// 									<Typography
// 										variant="button"
// 										gutterBottom
// 										className="letter-animation"
// 										color="primary"
// 										sx={{
// 											fontSize: '14px',
// 											textTransform: 'none',
// 											backgroundColor: '#FAEAEA',
// 											padding: '8px 16px',
// 											textAlign: 'center',
// 											fontWeight: '700',
// 										}}
// 									>
// 										Planning Fabulous
// 									</Typography>
// 								</SlideUp>
// 								<SlideUp style={{ animationDelay: '0.2s' }}>
// 									<StyledTypographhheroheanding
// 										variant="h3"
// 										gutterBottom
// 										className="letter-animation"
// 										sx={{
// 											color: 'black',
// 											fontSize: { xs: '24px', sm: '32px', md: '33.58px' },
// 											fontWeight: '900',
// 										}}
// 									>
// 										Book Us for your Dream Event
// 									</StyledTypographhheroheanding>
// 								</SlideUp>
// 								<SlideUp style={{ animationDelay: '0.3s' }}>
// 									<Typography
// 										variant="body1"
// 										className="letter-animation"
// 										sx={{
// 											fontFamily: 'Montserrat',
// 											color: '#515151',
// 											fontSize: '12px',
// 											fontWeight: '700',
// 										}}
// 									>
// 										Book our catering service today and let’s turn your special
// 										event into a delicious and memorable experience with
// 										seamless planning and exceptional flavors!
// 									</Typography>
// 								</SlideUp>
// 								<SlideUp style={{ animationDelay: '0.4s' }}>
// 									<Button
// 										variant="contained"
// 										className="letter-animation"
// 										color="primary"
// 										sx={{
// 											marginTop: '1rem',
// 										}}
// 										onClick={() => navigate('/customized-menu')}
// 									>
// 										Book Now
// 									</Button>
// 								</SlideUp>
// 								<SlideUp style={{ animationDelay: '0.4s' }}>
// 									<List
// 										sx={{
// 											width: '100%',
// 											bgcolor: 'background.paper',
// 											borderRadius: '7.61px',
// 											marginTop: '2rem',
// 										}}
// 										component="nav"
// 										aria-labelledby="nested-list-subheader"
// 									>
// 										<ListItem>
// 											<ListItemIcon>
// 												<CallIcon fontSize="large" />
// 											</ListItemIcon>
// 											<ListItemText
// 												primary={
// 													<Typography
// 														color="primary"
// 														variant="h6"
// 														sx={{
// 															fontFamily: 'Poppins',
// 															fontWeight: 600,
// 															fontSize: '17.39px',
// 															lineHeight: 1,
// 															textAlign: 'start',
// 														}}
// 													>
// 														<a
// 															href="tel:+919500066066"
// 															style={{
// 																color: 'inherit',
// 																textDecoration: 'none',
// 															}}
// 														>
// 															+91 9500066066
// 														</a>
// 														,{' '}
// 														<a
// 															href="tel:+919884433383"
// 															style={{
// 																color: 'inherit',
// 																textDecoration: 'none',
// 															}}
// 														>
// 															9884433383
// 														</a>
// 													</Typography>
// 												}
// 												secondary={
// 													<Typography
// 														// sx={{
// 														// 	fontFamily: 'Poppins',
// 														// 	fontWeight: 400,
// 														// 	fontSize: '9.54px',
// 														// 	marginTop: '0.5rem',
// 														// }}
// 														variant="body2"
// 														sx={{
// 															fontSize: { xs: '11px', sm: '14px' },
// 														}}
// 													>
// 														Contact us for delicious catering services
// 														and book your event today! Enjoy a special
// 														complimentary with your order!
// 													</Typography>
// 												}
// 											/>
// 										</ListItem>
// 									</List>
// 								</SlideUp>
// 							</TextContainer>
// 						</Grid>
// 					</Grid>
// 				</Grid>
// 				<Grid
// 					size={{ lg: 6 }}
// 					sx={{
// 						display: { xs: 'none', md: 'none', lg: 'block' },
// 						height: 'inherit',
// 						position: 'relative',
// 					}}
// 				>
// 					<CardMedia
// 						component="img"
// 						image="/assets/anniversary.svg"
// 						alt="hero-image"
// 						sx={{
// 							width: '30%',
// 							height: '30%',
// 							objectFit: 'contain',
// 							position: 'absolute',
// 							top: '30px',
// 						}}
// 					/>
// 					<CardMedia
// 						component="img"
// 						image="/assets/free-sapadu.svg"
// 						alt="hero-image"
// 						sx={{
// 							width: '30%',
// 							height: '30%',
// 							objectFit: 'contain',
// 							position: 'absolute',
// 							// top: '30px',
// 							right: { xs: 0, xl: '15%' },
// 						}}
// 					/>
// 					<CardMedia
// 						component="img"
// 						// image="/assets/home-image.png"
// 						image="/assets/home-image.webp"
// 						alt="hero-image"
// 						sx={{
// 							width: '100%',
// 							height: 'inherit',
// 						}}
// 					/>
// 				</Grid>
// 			</Grid>
// 		</Root>
// 	);
// };

// export default Herobanner;

// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
// ==============================================================================================================
import React from 'react';
import {
	Button,
	CardMedia,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import CallIcon from '@mui/icons-material/Call';
import {
	Root,
	SlideUp,
	StyledTypographhheroheanding,
	TextContainer,
} from '../../../component/ThemeComponent';
import './Heroheader.css'; // Import the CSS file for animations
// import FlagAnimation from './FlagAnimation';

const Herobanner = () => {
	const navigate = useNavigate();

	return (
		<Root>
			<Grid
				container
				spacing={2}
				direction="row"
				justifyContent="center"
				alignItems="center"
				sx={{ height: '100%' }}
			>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
					<Grid container>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}></Grid>
						<Grid size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
							<TextContainer
								className="hero-banner"
								sx={{ padding: { xs: '5px 20px', lg: '0px' } }}
							>
								<SlideUp style={{ animationDelay: '0.1s' }}>
									<Typography
										variant="button"
										gutterBottom
										className="letter-animation"
										color="primary"
										sx={{
											fontSize: '14px',
											textTransform: 'none',
											backgroundColor: '#FAEAEA',
											padding: '8px 16px',
											textAlign: 'center',
											fontWeight: '700',
										}}
									>
										Planning Fabulous
									</Typography>
								</SlideUp>
								<SlideUp style={{ animationDelay: '0.2s' }}>
									<StyledTypographhheroheanding
										variant="h3"
										gutterBottom
										className="letter-animation"
										sx={{
											color: 'black',
											fontSize: { xs: '24px', sm: '32px', md: '33.58px' },
											fontWeight: '900',
										}}
									>
										Book Us for your Dream <br /> Event
									</StyledTypographhheroheanding>
								</SlideUp>
								<SlideUp style={{ animationDelay: '0.3s' }}>
									<Typography
										variant="body1"
										className="letter-animation"
										sx={{
											fontFamily: 'Montserrat',
											color: '#515151',
											fontSize: '12px',
											fontWeight: '700',
										}}
									>
										Book our catering service today and let’s turn your special
										event into a delicious and memorable experience with
										seamless planning and exceptional flavors!
									</Typography>
								</SlideUp>
								<SlideUp style={{ animationDelay: '0.4s' }}>
									<Button
										variant="contained"
										className="letter-animation"
										color="primary"
										sx={{
											marginTop: '1rem',
										}}
										onClick={() => navigate('/customized-menu')}
									>
										Get Free Quotation
									</Button>
								</SlideUp>
								<SlideUp style={{ animationDelay: '0.4s' }}>
									<List
										sx={{
											width: '100%',
											bgcolor: 'background.paper',
											borderRadius: '7.61px',
											marginTop: '2rem',
										}}
										component="nav"
										aria-labelledby="nested-list-subheader"
									>
										<ListItem>
											<ListItemIcon>
												<CallIcon fontSize="large" />
											</ListItemIcon>
											<ListItemText
												primary={
													<Typography
														color="primary"
														variant="h6"
														sx={{
															fontFamily: 'Poppins',
															fontWeight: 600,
															fontSize: '17.39px',
															lineHeight: 1,
															// textAlign: 'center',
														}}
													>
														<a
															href="tel:+919500066066"
															style={{
																color: 'inherit',
																textDecoration: 'none',
															}}
														>
															+91 9500066066
														</a>
														,{' '}
														<a
															href="tel:+919884433383"
															style={{
																color: 'inherit',
																textDecoration: 'none',
															}}
														>
															9884433383
														</a>
													</Typography>
												}
												secondary={
													<Typography
														// sx={{
														// 	fontFamily: 'Poppins',
														// 	fontWeight: 400,
														// 	fontSize: '9.54px',
														// 	marginTop: '0.5rem',
														// }}
														variant="body2"
														sx={{
															fontSize: { xs: '11px', sm: '14px' },
														}}
													>
														Contact us for delicious catering services
														and book your event today! Enjoy a special
														complimentary with your order!
													</Typography>
												}
											/>
										</ListItem>
									</List>
								</SlideUp>
							</TextContainer>
						</Grid>
					</Grid>
				</Grid>
				<Grid
					size={{ lg: 6 }}
					sx={{
						height: 'inherit',
						position: 'relative',
					}}
				>
					<CardMedia
						component="img"
						image="/assets/anniversary.svg"
						alt="hero-image"
						sx={{
							width: '30%',
							height: '30%',
							objectFit: 'contain',
							position: 'absolute',
							top: '30px',
							display: { xs: 'none', md: 'none', lg: 'block' },
						}}
					/>
					{/* <Typography
						sx={{
							// width: '30%',
							// height: '30%',
							// objectFit: 'contain',
							// position: 'absolute',
						}}
					> */}
					{/* <Box sx={{ display: 'block' }}>
						<FlagAnimation />
					</Box> */}
					{/* </Typography> */}
					<CardMedia
						component="img"
						// image="/assets/home-image.png"
						image="/assets/home-image.webp"
						alt="hero-image"
						sx={{
							width: '100%',
							height: 'inherit',
							display: { xs: 'none', md: 'none', lg: 'block' },
						}}
					/>
					{/* <Box>
						<FlagAnimation />
					</Box> */}
				</Grid>
				{/* <CardMedia
					component="img"
					image="/assets/anniversary.svg"
					alt="hero-image"
					sx={{
						width: {xs: '15%', sm: '30%', md: '30%', lg: '30%'},
						height: 'auto',
						objectFit: 'contain',
						position: 'absolute',
						top: { xs: '15%', sm: '32%', md: '32%' },
						right: { xs: '3%', sm: '14%', md: '7%', lg: '15%' },
						display: { xs: 'block', md: 'block', lg: 'none' },
					}}
				/> */}
			</Grid>
		</Root>
	);
};

export default Herobanner;
